<template>
    <div class="Menu">
		<div class="Menu__links">
			<div class="navLink" @click="goToPage('početna')">{{ $t('MenuLinkHome') }}</div>
			<div class="navLink" @click="goToPage('usluge')">{{ $t('MenuLinkServices') }}</div>
			<div class="navLink" @click="goToPage('galerija')">{{ $t('MenuLinkGallery') }}</div>
			<div class="navLink" @click="goToPage('reference')">{{ $t('MenuLinkReferences') }}</div>
			<div class="navLink" @click="goToPage('kontakt')">{{ $t('MenuLinkContact') }}</div>
		</div>
		<div class="Menu__lang">
			<div @click="setActiveLanguage('bs')" :class="{ activeLang: activeLanguage === 'bs'}">
				<img src="@/assets/images/bosnia-flag.png">
			</div>
			<div @click="setActiveLanguage('de')" :class="{ activeLang: activeLanguage === 'de'}">
				<img src="@/assets/images/german-flag.png">
			</div>
		</div>
        
    </div>
</template>

<script>

export default {
	name: 'Menu',
	created() {
		this.setInitialValue()
	},
	data() {
		return {
			activeLanguage: 'bs'
		}
	},
	watch: {
        activeLanguage(lang) {
            this.$i18n.set(lang)
			localStorage.setItem('language', lang)
        },
    },
    methods: {
        goToPage(link) {
            this.$router.push(`/${link}`)
		},
		setActiveLanguage(lang) {
			this.activeLanguage = lang
        },
        setInitialValue() {
            const storedLanguage = localStorage.getItem('language')
            this.activeLanguage = storedLanguage
        }
    }
}
</script>

<style lang="scss" scoped>

.Menu {
    display: none;

	@media screen and (min-width: 1024px) {
		display: flex;
		align-items: center;
	}

	&__links {
		display: flex;

		.navLink {
			margin: 0 10px;
			color: $blue;
			font-weight: 400;
			transition: 0.3s;

			&:hover {
				cursor: pointer;
				transition: 0.3s;
				color: lighten($grey, 5);
			}
		}
	}

	&__lang {
		display: flex;
		align-items: center;

		div	{
			width: 25px;
			height: 25px;
			display: flex;
			margin: 0 10px;
			cursor: pointer;

			img {
				width: 100%;
				filter: grayscale(100%);
			}
		}
	}
    
}

.activeLang {
	img {
		filter: grayscale(0%) !important;
	}
}
</style>
